<div class="tasks">

    <sc-master-detail [selection]="[selectedTask]" [data]="tasks" [newStyle]="true"
        (selectionChanged)="onSelectionChanged($event);" (addEntry)="onAddEntry($event);"
        (deleteEntry)="onDeleteEntry($event);">
        <ng-container *ngIf="workingCopyDetails">
            <form #displayForm="ngForm" class="form">
                <div class="task-details">
                    <div class="scrollable">
                        <div class="form-box grid" *ngIf="workingCopyDetails">

                            <mat-form-field style="grid-column: 1; grid-row: 1;">
                                <input [(ngModel)]="workingCopyDetails.sortOrder" name="sortOrder" matInput
                                    placeholder="{{'sort order' | translate: ['tmc.admin.tasks.sortOrder', translationService.language]}}"
                                    [required]="false" [maxlength]="10" [minlength]="0" />
                            </mat-form-field>

                            <sc-dictionary-field style="grid-column: 1; grid-row: 2;" [model]="workingCopyDetails.name"
                                [defaultLabel]="'name'" [labelDictionaryKey]="'tmc.admin.tasks.name'" [required]="true"
                                [maxlength]="255" (dictionaryChanged)="onDictionaryChanged()">
                            </sc-dictionary-field>

                            <mat-form-field style="grid-column: 1; grid-row: 3;">
                                <mat-label>
                                    {{'execution type' | translate: ['tmc.admin.tasks.executionType',
                                    translationService.language]}}
                                </mat-label>
                                <mat-select [(ngModel)]="workingCopyDetails.executionType" name="executionType">
                                    <mat-option *ngFor="let o of taskExecutionTypes" value="{{o}}">
                                        {{o | translate: ['tmc.admin.tasks.executionType.' + o,
                                        translationService.language]}}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>

                            <mat-form-field style="grid-column: 1; grid-row: 4;">
                                <mat-label>
                                    {{'type' | translate: ['tmc.admin.tasks.type', translationService.language]}}
                                </mat-label>
                                <mat-select [required]="true" [(ngModel)]="workingCopyDetails.type" name="type">
                                    <mat-option *ngFor="let o of taskTypes" value="{{o}}" >
                                        {{o | translate: ['tmc.admin.tasks.type.' + o,
                                        translationService.language]}}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>

                            <ng-container *ngIf="this.workingCopyDetails.type === taskType.MESSAGE">
                                <sc-dictionary-field style="grid-column: 1; grid-row: 5;"
                                    [model]="workingCopyDetails.message" [defaultLabel]="'message'"
                                    [labelDictionaryKey]="'tmc.admin.tasks.message'"
                                    [required]="this.workingCopyDetails.type === taskType.MESSAGE" [maxlength]="255"
                                    (dictionaryChanged)="onDictionaryChanged()">
                                </sc-dictionary-field>
                            </ng-container>

                            <ng-container *ngIf="this.workingCopyDetails.type === taskType.DOCUMENT">
                                <div class="document-selection" style="grid-column: 1; grid-row: 5;">
                                    <mat-form-field class="mat-form-field-readonly station-name">

                                        <input matInput
                                            [value]="'' | translate: [workingCopyDetails.documentTemplate.nameDictionaryKey, translationService.language ]"
                                            placeholder="{{'document ' | translate: ['tmc.admin.tasks.document', translationService.language]}}"
                                            required [readonly]="true"
                                            *ngIf="workingCopyDetails.documentTemplate != null">

                                        <input matInput [value]="''"
                                            placeholder="{{'document ' | translate: ['tmc.admin.tasks.document', translationService.language]}}"
                                            required [readonly]="true"
                                            *ngIf="workingCopyDetails.documentTemplate == null">

                                    </mat-form-field>

                                    <button mat-flat-button type="button" (click)="selectDocument()"
                                        class="small-button select-button">
                                        <sc-icon iconClass="fa-file"></sc-icon></button>
                                </div>
                            </ng-container>

                            <ng-container *ngIf="this.workingCopyDetails.type === taskType.ATTRIBUTE_CHANGE">
                                <mat-form-field style="grid-column: 1; grid-row: 5;">
                                    <input [(ngModel)]="workingCopyDetails.orderReferenceOld" name="orderReferenceOld"
                                        matInput
                                        placeholder="{{'orde reference old' | translate: ['tmc.admin.tasks.order-reference-old', translationService.language]}}"
                                        [required]="true" [maxlength]="255" />
                                </mat-form-field>
                                <mat-form-field style="grid-column: 1; grid-row: 6;">
                                    <input [(ngModel)]="workingCopyDetails.orderReferenceNew" name="orderReferenceNew"
                                        matInput
                                        placeholder="{{'orde reference new' | translate: ['tmc.admin.tasks.order-reference-new', translationService.language]}}"
                                        [required]="true" [maxlength]="255" />
                                </mat-form-field>
                            </ng-container>

                            <mat-form-field>
                                <textarea matInput [rows]="3" name="processingHint" [required]="false" [minLength]="0"
                                    placeholder="{{'processing hint' | translate: ['tmc.admin.tasks.processing-hint', translationService.language]}}"
                                    [(ngModel)]="workingCopyDetails.processingHint"></textarea>
                            </mat-form-field>
                        </div>
                    </div>
                </div>


            </form>
        </ng-container>

        <ng-template masterDetailToolbar>

            <button mat-stroked-button type="button" class="config-changed-button" (click)="cancel()"
                [disabled]="!cancelEnabled">{{'cancel'
                | translate: ['tmc.admin.tasks.action.cancel', translationService.language]}}</button>
            <sc-content-spacer></sc-content-spacer>
            <button mat-flat-button type="button" class="config-changed-button" (click)="save()" [disabled]="!saveEnabled">
                {{'save'
                | translate: ['tmc.admin.tasks.action.save',
                translationService.language]}}</button>
        </ng-template>

    </sc-master-detail>

</div>
